<template>
  <icon class="pc-icon-lamp-desk" @click="$emit('click')">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path fill="currentColor" d="M494.42,64H369.14L328.57,23.43A80,80,0,0,0,215.43,136.57l4.69,4.68L116.69,244.67a16.06,16.06,0,0,0-4.07,15.8L158,416H80c-35.09,0-68.12,23.22-78.53,55.2A30.19,30.19,0,0,0,6,498.55,32.64,32.64,0,0,0,32.27,512H351.73A32.64,32.64,0,0,0,378,498.55a30.21,30.21,0,0,0,4.47-27.36C372,439.2,339,416,304,416H191.35L146,260.59l96.74-96.71L256,177.14V302.42A17.53,17.53,0,0,0,273.67,320,17.18,17.18,0,0,0,286,314.82l60.16-60.16C358.6,265.24,374.39,272,392,272a72.08,72.08,0,0,0,72-72c0-17.61-6.75-33.4-17.33-45.87L506.82,94C517.88,82.9,510.05,64,494.42,64ZM304,448c21.6,0,41.84,13.94,47.75,32H31.93c6.25-19.19,26.46-32,48.09-32Zm88-208a38.92,38.92,0,0,1-23.37-7.83l55.54-55.54A38.94,38.94,0,0,1,432,200,40,40,0,0,1,392,240ZM288,267.53V163.88l-49.94-49.94a48,48,0,0,1,67.88-67.88L355.88,96H459.53Z" class=""></path>
    </svg>
  </icon>
</template>

<script>
import Icon from '@/components/icon/IconContainer.vue'

export default {
  components: {
    Icon
  }
}
</script>

<style lang="scss">
.pc-icon-lamp-desk svg {
  width: 1em;
}
</style>
